import { render } from "./MainLayout.vue?vue&type=template&id=408d60f5&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=408d60f5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-408d60f5"

export default script